import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', padding: '4rem' }}>
      <h1>Payment cancelled</h1>
      <p>You can try again whenever you want.</p>
      <button
        onClick={() => navigate('/subscription')}
        style={{ marginTop: '1rem', padding: '0.75rem 1.25rem', cursor: 'pointer' }}
      >
        Back to subscription
      </button>
    </div>
  );
};

export default PaymentCancel;

